import React from "react";
import "./Ruko.scss";
import data from "./data.json";
import Card from "../../Component/Card Ruko/cardruko";
import Rukocleonimages from "../../Media/Ruko/Ruko Cleon/Rukocleon";
import Neweastimages from "../../Media/Ruko/apartcleon";
import jbdimages from "../../Media/Ruko/JBD";
import Genovaimages from "../../Media/Ruko/Genova";
import NeoSohoimages from "../../Media/Ruko/Neo Soho/NeoSoho";

const imageMap = {
  Rukocleonimages,
  Neweastimages,
  jbdimages,
  Genovaimages,
  NeoSohoimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="ruko" className="ruko">
      <h1>Ruko Komersial Siap Huni</h1>
      <h2>Cicilan Start 13 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
